define('companiesDetailBodyView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'companiesDetailBodyTabsView',
  'template!companiesDetailBodyView'
], function (
  App,
  Module,
  Marionette,
  _,
  CompaniesDetailBodyTabsView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'companies-detail-body-view',

    regions: {
      tabsRegion: '.tabs-region',
      infoRegion: '.info.region',
      subaccountsRegion: '.subaccounts.region',
      ordersRegion: '.orders.region',
      offersRegion: '.offers.region'
    },

    onShow: function () {
      this.tabsView = new CompaniesDetailBodyTabsView({
        model: this.model
      });
      this.getRegion('tabsRegion').show(this.tabsView);
      this.tabsView.setSelected(this.options.tabName);
      this.tabsView.on('select', _.bind(this.selectTab, this));
      this.selectTab(this.tabsView.getSelected());
    },

    selectTab: function (tab) {
      if (!tab) {
        return;
      }
      this.$el.find('.region').removeClass('selected');
      this.$el.find('.' + tab.get('name') + '.region').addClass('selected');

      App.navigate('companies/' + this.model.get('secId') + '/' + tab.get('name'));
      App.currentUrl = App.getCurrentRoute();

      switch (tab.get('name')) {
        case 'info':
          require([
            'companiesDetailBodyInfoView'
          ], _.bind(function (View) {
            if (!this.infoView) {
              this.infoView = new View({
                model: this.model
              });
              this.getRegion('infoRegion').show(this.infoView);
            }
          }, this));
          break;
        case 'subaccounts':
          require([
            'companiesDetailBodySubaccountsView'
          ], _.bind(function (View) {
            if (!this.subaccountsView) {
              this.subaccountsView = new View({
                model: this.model
              });
              this.getRegion('subaccountsRegion').show(this.subaccountsView);
            }
          }, this));
          break;
        case 'orders':
          require([
            'companiesDetailBodyOrdersView'
          ], _.bind(function (View) {
            if (!this.ordersView) {
              this.ordersView = new View({
                type: 'command',
                companySecId: this.model.get('secId')
              });
              this.getRegion('ordersRegion').show(this.ordersView);
            }
          }, this));
          break;
        case 'offers':
          require([
            'companiesDetailBodyOffersView'
          ], _.bind(function (View) {
            if (!this.offersView) {
              this.offersView = new View({
                type: 'offer',
                companySecId: this.model.get('secId')
              });
              this.getRegion('offersRegion').show(this.offersView);
            }
          }, this));
          break;
      }
    }
  });
});

